export enum StatusMessages {
	AddedOne = "watchlist_add_asset_success_message",
	AddedMultiple = "watchlist_add_assets_success_message",
	DragAndDrop = "watchlist_page_switch_success",
	RemoveAssetMessage = "watchlist_remove_asset_success_message"
}
